var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"timer-display",class:{ 'timer-warning': _vm.timer > 0 && _vm.timer < 10 },staticStyle:{"display":"flex","align-items":"center"}},[_c('span',[_vm._v("⏰")]),(_vm.timer > 0)?_c('span',{key:_vm.timerDisplay},[_vm._v(_vm._s(_vm.timerDisplay))]):_c('span',[_vm._v("0:00")])])
}
var staticRenderFns = []

export { render, staticRenderFns }